import React from 'react';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import { Text } from '../../../components';
import classNames from 'classnames';

import './CardTrendPercentage.scss';

export const CardTrendPercentage = ({ arrowDirection, status, percentValue, className = '' }) => {
    const classes = classNames('card-trend-percentage', className, {
        ready: status === 'ready',
        danger: status === 'danger',
        warning: status === 'warning',
    });
    return (
        <span className={classes}>
            {arrowDirection === 'up' && <ArrowUpOutlined className="card-trend-percentage-icon" />}
            {arrowDirection === 'down' && <ArrowDownOutlined className="card-trend-percentage-icon" />}
            <Text size="small">{percentValue}</Text>
        </span>
    );
};
